// RequireCustomer.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCustomerAuth } from "../../../context/CustomerAuthContext/CustomerAuthContext";

const RequireCustomer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated,  } = useCustomerAuth(); // token yerine bunları kullan
  const loc = useLocation();


  if (!isAuthenticated) {
    // tüm location'ı taşı: {pathname, search, hash, state}
    return <Navigate to="/musteri/giris" state={{ from: loc }} replace />;
  }

  return <>{children}</>;
};

export default RequireCustomer;
